import { createGlobalStyle } from 'styled-components';

import { EVENT_TITLE_HEIGHT } from '../constants';

export const ZoomMeetingGlobalStyle = createGlobalStyle`

  header {
    display: none;
  }

  #main-container {
    padding-top: 0 !important;
  }

  #zmmtg-root {
    top: ${EVENT_TITLE_HEIGHT}px !important;
    height: calc(100vh - ${EVENT_TITLE_HEIGHT}px) !important;
  }

  video-player-container > div > div:last-child, .sharing-layout {
    transform: scale(var(--video-share-layout-scale, 1));
    transform-origin: top;
  }

  [data-testid="main-group-header"] {
    display: none;
  }

`;
